import React from "react";
import { Link } from "react-router-dom";
import "./About.css";
import {
  MdEnergySavingsLeaf,
  MdBiotech,
  MdHandshake,
  MdScience,
} from "react-icons/md";
function TeamCard({ name, role, desc, initials }) {
  return (
    <div className="team-card">
      <div className="team-card__avatar">{initials}</div>
      <h3 className="team-card__name">{name}</h3>
      <p className="team-card__role">{role}</p>
      <p className="team-card__desc">{desc}</p>
    </div>
  );
}

function ValueCard({ icon, title, desc }) {
  return (
    <div className="value-card">
      <span className="value-card__icon">{icon}</span>
      <h3 className="value-card__title">{title}</h3>
      <p className="value-card__desc">{desc}</p>
    </div>
  );
}

export default function About() {
  const team = [
    {
      name: "Ahmet Yılmaz",
      role: "Kurucu & CEO",
      initials: "AY",
      desc: "Robotik mühendisi. 10+ yıl endüstriyel otomasyon deneyimi. Tarım robotları üzerine araştırmacı.",
    },
    {
      name: "Zeynep Kaya",
      role: "CTO",
      initials: "ZK",
      desc: "Yapay zeka ve bilgisayarlı görü uzmanı. Doktora: Otonom Sistemler. Önceki deneyim: TÜBITAK.",
    },
    {
      name: "Murat Demir",
      role: "Ar-Ge Müdürü",
      initials: "MD",
      desc: "Makine mühendisi. Gömülü sistemler ve IoT konusunda 8 yıllık endüstri tecrübesi.",
    },
    {
      name: "Elif Şahin",
      role: "Yazılım Mimarı",
      initials: "EŞ",
      desc: "Full-stack ve robotik yazılım geliştirici. ROS2, Python ve edge computing konularında uzman.",
    },
    {
      name: "Can Arslan",
      role: "Donanım Mühendisi",
      initials: "CA",
      desc: "Elektronik ve mekatronik mühendisi. PCB tasarım ve sensör entegrasyon uzmanı.",
    },
    {
      name: "Selin Öztürk",
      role: "Tarım Danışmanı",
      initials: "SÖ",
      desc: "Ziraat mühendisi. Çiftçilerle sahada yürütülen pilot projelerin koordinatörü.",
    },
  ];

  const values = [
    {
      icon: (
        <MdEnergySavingsLeaf
          size={32}
          style={{ color: "var(--clr-primary)" }}
        />
      ),
      title: "Sürdürülebilirlik",
      desc: "Her ürünümüzü çevre etkisini minimize edecek şekilde tasarlıyoruz. Kimyasal kullanımı ve su israfını azaltmak temel hedefimiz.",
    },
    {
      icon: <MdBiotech size={32} style={{ color: "var(--clr-primary)" }} />,
      title: "İnovasyon",
      desc: "Araştırma odaklı yaklaşımımızla sürekli yeni teknolojiler geliştiriyor, tarım sektörünü dönüştürüyoruz.",
    },
    {
      icon: <MdHandshake size={32} style={{ color: "var(--clr-primary)" }} />,
      title: "Çiftçi Odaklılık",
      desc: "Her çözüm, gerçek çiftçi ihtiyaçlarından doğar. Sahada birlikte test ederek gerçekçi ürünler üretiriz.",
    },
    {
      icon: <MdScience size={32} style={{ color: "var(--clr-primary)" }} />,
      title: "Bilim Temelli",
      desc: "Kararlarımızı veri ve bilimsel araştırmaya dayandırıyoruz. Üniversite ve araştırma kurumlarıyla aktif iş birlikleri sürdürüyoruz.",
    },
  ];

  const milestones = [
    {
      year: "2023",
      event:
        "Vincora kuruldu, otonom tarım robotları için Ar-Ge çalışmaları başlatıldı.",
    },
    {
      year: "2024",
      event:
        "İlk prototip geliştirildi, BTM İstanbul Ön Kuluçka Programı’na kabul edildi.",
    },
    {
      year: "2025",
      event:
        "YTÜ Startup House ve Marmara Teknokent programlarına kabul edildi, MVP geliştirme süreci başlatıldı.",
    },
    {
      year: "2026",
      event:
        "MVP geliştirme ve saha testleri devam ediyor, pilot müşteri süreçleri yürütülüyor.",
    },
  ];

  return (
    <div className="about-page page-enter">
      <div className="about-hero">
        <div className="container">
          <span className="section-label">Hikayemiz</span>
          <h1 className="about-hero__title">
            Tarımı Teknoloji ile
            <br />
            <span className="about-hero__accent">Yeniden Tanımlıyoruz</span>
          </h1>
          <p className="about-hero__subtitle">
            Vincora, tarımın sahadaki gerçek problemlerinden doğdu. Meyve
            bahçelerinde üretimin büyük ölçüde manuel yapılması ve veriye
            dayanmayan kararlar, daha akıllı ve sürdürülebilir çözümler
            geliştirme ihtiyacını ortaya çıkardı. Bu problemden yola çıkarak,
            robotik ve yapay zekayı bir araya getiren bir sistem geliştirdik.
            Amacımız yalnızca bir robot üretmek değil, tarımı veriye dayalı ve
            otonom bir yapıya dönüştürmekti. Bugün Vincora, sahadan veri
            toplayan, analiz eden ve bu veriyi otonom sistemlerle aksiyona
            dönüştüren bir platform geliştiriyor. Her ağacı ayrı değerlendiren
            bu yaklaşım ile tarımda yeni bir standart oluşturmayı hedefliyoruz.
          </p>
        </div>
      </div>

      {/* Mission */}
      <section className="section">
        <div className="container about-mission">
          <div className="about-mission__text">
            <span className="section-label">Misyonumuz</span>
            <h2 className="section-title">
              2030’a Kadar 50.000+ Hektarı Otonom Tarım Sistemleri ile
              Dönüştürmek
            </h2>
            <p
              style={{
                color: "var(--clr-text-muted)",
                lineHeight: 1.8,
                fontSize: "16px",
                marginBottom: "24px",
              }}
            >
              Vincora olarak amacımız, tarımı veri ve yapay zeka ile yeniden
              tanımlayarak meyve bahçelerini otonom ve verimli sistemlere
              dönüştürmektir. Geliştirdiğimiz robotik ve yapay zeka platformu
              ile üreticilerin daha az kaynakla daha yüksek verim elde etmesini
              sağlıyoruz.
            </p>
            <p
              style={{
                color: "var(--clr-text-muted)",
                lineHeight: 1.8,
                fontSize: "16px",
              }}
            >
              Tarımda manuel, veriye dayanmayan ve kaynak israfına yol açan
              geleneksel yöntemlerin yerine; her ağacı analiz eden, doğru
              zamanda doğru müdahaleyi yapan akıllı sistemler geliştiriyoruz.
            </p>
          </div>
          <div className="about-mission__stats">
            {[
              { v: "2023", l: "Kuruluş Yılı" },
              { v: "10+", l: "Uzman Ekip" },
              { v: "", l: "Ar-Ge ve Geliştirme Süreci" },
              { v: "", l: "Pilot Süreç Hazırlığı" },
            ].map((s, i) => (
              <div key={i} className="about-stat">
                <span className="about-stat__value">{s.v}</span>
                <span className="about-stat__label">{s.l}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="section about-values">
        <div className="container">
          <span className="section-label">Değerlerimiz</span>
          <h2 className="section-title">Bizi Yönlendiren İlkeler</h2>
          <div className="values-grid">
            {values.map((v, i) => (
              <ValueCard key={i} {...v} />
            ))}
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="section">
        <div className="container">
          <span className="section-label">Yolculuk</span>
          <h2 className="section-title">Kilometre Taşlarımız</h2>
          <div className="timeline">
            {milestones.map((m, i) => (
              <div key={i} className="timeline-item">
                <div className="timeline-year">{m.year}</div>
                <div className="timeline-dot-col">
                  <div className="timeline-dot" />
                  <div className="timeline-line" />
                </div>
                <div className="timeline-content">{m.event}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      {/* <section className="section about-team">
        <div className="container">
          <span className="section-label">Ekibimiz</span>
          <h2 className="section-title">Arkasındaki İnsanlar</h2>
          <p className="section-subtitle">
            Farklı disiplinlerden gelen uzmanlardan oluşan ekibimiz, tarımı
            teknoloji ile buluşturuyor.
          </p>
          <div className="team-grid">
            {team.map((t, i) => (
              <TeamCard key={i} {...t} />
            ))}
          </div>
        </div>
      </section> */}

      {/* Activities */}
      <section className="section partners about-partners">
        <div className="container">
          <span className="section-label">Etkinlikler</span>
          <h2 className="section-title">Katıldığımız Programlar</h2>
          <div className="partners-row">
            {[
              "BTM İstanbul - Ön Kuluçka Programı",
              "YTÜ Startup House - Ön Kuluçka Programı",
              "Marmara Teknokent - Ön Kuluçka Programı",
              "Bilişim Vadisi - Girişim Programı",
            ].map((p, i) => (
              <div key={i} className="partner-badge">
                {p}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="cta-banner" style={{ marginTop: 0 }}>
        <div className="container cta-banner__inner">
          <div>
            <h2 className="cta-banner__title">
              Ekibimize Katılmak İster misiniz?
            </h2>
            <p className="cta-banner__subtitle">
              Tarımın geleceğini birlikte inşa ediyoruz. Açık pozisyonlar için
              bizimle iletişime geçin.
            </p>
          </div>
          <Link to="/contact" className="btn btn-primary">
            İletişime Geç
          </Link>
        </div>
      </section>
    </div>
  );
}
